/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const GoteborgIcon = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="247.01px"
        height="149.91px"
        viewBox="0 0 247.01 149.91"
        xmlSpace="preserve"
        className={className}
    >
        <g>
            <path
                fill={color}
                d="M3.6,110.71c0,3.27,2.15,5.61,5.21,5.61c3.06,0,5.21-2.34,5.21-5.61c0-3.32-2.15-5.68-5.21-5.68
    		C5.75,105.04,3.6,107.39,3.6,110.71L3.6,110.71z M17.64,110.71c0,5.12-3.78,8.86-8.83,8.86c-5.07,0-8.81-3.74-8.81-8.86
    		c0-5.16,3.74-8.92,8.81-8.92C13.85,101.79,17.64,105.55,17.64,110.71L17.64,110.71z"
            />
            <polygon
                fill={color}
                points="31.11,105.34 23.94,105.34 23.94,109.29 29.9,109.29 29.9,112.32 23.94,112.32 23.94,119.26
    		20.37,119.26 20.37,102.09 31.11,102.09 31.11,105.34 	"
            />
            <polygon
                fill={color}
                points="44.77,105.34 37.6,105.34 37.6,109.29 43.56,109.29 43.56,112.32 37.6,112.32 37.6,119.26
    		34.03,119.26 34.03,102.09 44.77,102.09 44.77,105.34 	"
            />
            <polygon
                fill={color}
                points="51.38,119.26 47.81,119.26 47.81,102.09 51.38,102.09 51.38,119.26 	"
            />
            <path
                fill={color}
                d="M69.16,104.36l-2.24,2.59c-0.91-1.07-2.22-1.92-3.97-1.92c-3.15,0-5.21,2.36-5.21,5.63
    		c0,3.27,2.06,5.65,5.21,5.65c1.78,0,3.11-0.86,4.02-1.96l2.22,2.59c-1.71,1.87-3.74,2.62-6.24,2.62c-5.16,0-8.81-3.81-8.81-8.9
    		c0-5.07,3.64-8.88,8.81-8.88C65.65,101.79,67.5,102.65,69.16,104.36L69.16,104.36z"
            />
            <polygon
                fill={color}
                points="75.34,119.26 71.77,119.26 71.77,102.09 75.34,102.09 75.34,119.26 	"
            />
            <path
                fill={color}
                d="M83.84,113.82h4.34l-2.17-5.14L83.84,113.82L83.84,113.82z M94.36,119.26h-3.92l-1.12-2.66h-6.59l-1.12,2.66
    		h-3.93l8.29-17.47h0.09L94.36,119.26L94.36,119.26z"
            />
            <polygon
                fill={color}
                points="100.22,116.13 107.53,116.13 107.53,119.26 96.64,119.26 96.64,102.09 100.22,102.09 100.22,116.13
    		"
            />
            <path
                fill={color}
                d="M127.1,103.59l-1.85,2.94c-1.05-0.84-2.36-1.49-4.18-1.49c-1.52,0-2.45,0.61-2.45,1.87
    		c0,0.98,0.65,1.47,3.22,1.96c4.44,0.93,5.84,2.55,5.84,5.18c0,3.29-2.45,5.51-6.49,5.51c-2.62,0-4.95-0.82-6.66-2.29l1.94-2.97
    		c1.14,1.21,3.08,2.01,4.84,2.01c1.8,0,2.83-0.68,2.83-1.94c0-1.01-0.77-1.57-3.32-2.06c-4.44-0.96-5.77-2.73-5.77-5.25
    		c0-3.08,2.36-5.28,6.05-5.28C123.55,101.79,125.67,102.49,127.1,103.59L127.1,103.59z"
            />
            <polygon
                fill={color}
                points="141.56,105.34 134.03,105.34 134.03,109.05 140.55,109.05 140.55,112.07 134.03,112.07 134.03,116.02
    		141.74,116.02 141.74,119.26 130.46,119.26 130.46,102.09 141.56,102.09 141.56,105.34 	"
            />
            <polygon
                fill={color}
                points="148.86,116.13 156.18,116.13 156.18,119.26 145.29,119.26 145.29,102.09 148.86,102.09 148.86,116.13
    			"
            />
            <polygon
                fill={color}
                points="169.89,105.34 162.36,105.34 162.36,109.05 168.88,109.05 168.88,112.07 162.36,112.07 162.36,116.02
    		170.07,116.02 170.07,119.26 158.79,119.26 158.79,102.09 169.89,102.09 169.89,105.34 	"
            />
            <path
                fill={color}
                d="M187.33,104.36l-2.24,2.59c-0.91-1.07-2.22-1.92-3.97-1.92c-3.15,0-5.21,2.36-5.21,5.63
    		c0,3.27,2.06,5.65,5.21,5.65c1.78,0,3.11-0.86,4.02-1.96l2.22,2.59c-1.71,1.87-3.74,2.62-6.24,2.62c-5.16,0-8.81-3.81-8.81-8.9
    		c0-5.07,3.64-8.88,8.81-8.88C183.83,101.79,185.68,102.65,187.33,104.36L187.33,104.36z"
            />
            <polygon
                fill={color}
                points="203.45,105.22 197.86,105.22 197.86,119.26 194.31,119.26 194.31,105.22 188.75,105.22 188.75,102.09
    		203.45,102.09 203.45,105.22 	"
            />
            <polygon
                fill={color}
                points="209.8,119.26 206.22,119.26 206.22,102.09 209.8,102.09 209.8,119.26 	"
            />
            <path
                fill={color}
                d="M216.31,110.71c0,3.27,2.15,5.61,5.21,5.61c3.06,0,5.21-2.34,5.21-5.61c0-3.32-2.15-5.68-5.21-5.68
    		C218.46,105.04,216.31,107.39,216.31,110.71L216.31,110.71z M230.35,110.71c0,5.12-3.78,8.86-8.83,8.86
    		c-5.07,0-8.81-3.74-8.81-8.86c0-5.16,3.74-8.92,8.81-8.92C226.57,101.79,230.35,105.55,230.35,110.71L230.35,110.71z"
            />
            <polygon
                fill={color}
                points="247.01,119.57 246.91,119.57 236.77,109.68 236.77,119.26 233.2,119.26 233.2,101.79 233.29,101.79
    		243.43,111.67 243.43,102.09 247.01,102.09 247.01,119.57 	"
            />
            <polygon
                fill={color}
                points="123.09,134.94 117.45,134.94 117.45,138.47 122.19,138.47 122.19,140.39 117.45,140.39 117.45,145.74
    		115.27,145.74 115.27,132.94 123.09,132.94 123.09,134.94 	"
            />
            <path
                fill={color}
                d="M126.82,145.74h-2.08v-8.78h2.08V145.74L126.82,145.74z M127.08,134.15c0,0.75-0.56,1.29-1.31,1.29
    		c-0.73,0-1.29-0.54-1.29-1.29c0-0.75,0.56-1.29,1.29-1.29C126.52,132.87,127.08,133.41,127.08,134.15L127.08,134.15z"
            />
            <polygon
                fill={color}
                points="131.26,145.74 129.17,145.74 129.17,132.5 131.26,132.5 131.26,145.74 	"
            />
            <path
                fill={color}
                d="M140.64,138.33c0.64-0.91,1.6-1.55,3.01-1.55c2.02,0,3.17,1.51,3.17,3.81v5.14h-2.11v-5.02
    		c0-1.17-0.61-1.97-1.63-1.97c-0.89,0-1.52,0.58-1.97,1.25c0,0.14,0.02,0.28,0.02,0.4v5.33h-2.11v-5.02c0-1.17-0.61-1.97-1.63-1.97
    		c-0.89,0-1.48,0.58-1.95,1.22v5.77h-2.09v-8.78h1.88l0.09,1.01c0.49-0.63,1.36-1.18,2.65-1.18
    		C139.21,136.79,140.12,137.36,140.64,138.33L140.64,138.33z"
            />
            <polygon
                fill={color}
                points="160.91,134.94 155.27,134.94 155.27,138.47 160,138.47 160,140.39 155.27,140.39 155.27,145.74
    		153.09,145.74 153.09,132.94 160.91,132.94 160.91,134.94 	"
            />
            <path
                fill={color}
                d="M163.38,140.49h4.14c-0.05-1.2-0.75-2.04-2-2.04C164.29,138.46,163.45,139.28,163.38,140.49L163.38,140.49z
    		 M169.58,141.26v0.73h-6.19c0.05,1.39,0.89,2.16,2.35,2.16c1.03,0,1.78-0.45,2.18-1.01l1.45,1.18c-0.87,1.04-2.02,1.58-3.64,1.58
    		c-2.72,0-4.46-1.91-4.46-4.54c0-2.65,1.78-4.58,4.3-4.58C168.26,136.79,169.58,138.8,169.58,141.26L169.58,141.26z"
            />
            <path
                fill={color}
                d="M177.42,137.74l-0.84,1.55c-0.52-0.42-1.22-0.77-2.14-0.77c-0.87,0-1.39,0.26-1.39,0.87
    		c0,0.59,0.42,0.77,1.73,1.08c1.95,0.47,2.87,1.31,2.87,2.63c0,1.69-1.41,2.8-3.68,2.8c-1.32,0-2.57-0.4-3.34-1.06l0.87-1.57
    		c0.63,0.52,1.48,0.89,2.49,0.89c0.94,0,1.53-0.3,1.53-0.94c0-0.59-0.42-0.85-1.69-1.15c-2-0.47-2.87-1.17-2.87-2.54
    		c0-1.71,1.32-2.75,3.48-2.75C175.64,136.79,176.74,137.17,177.42,137.74L177.42,137.74z"
            />
            <path
                fill={color}
                d="M182.08,136.96v-2.94h-2.09v2.94h-1.65v1.78h1.65v3.9c0,2.13,1.27,3.27,3.27,3.27c0.87,0,1.51-0.24,1.95-0.52
    		l-0.56-1.64c-0.26,0.15-0.64,0.28-1.2,0.28c-0.82,0-1.38-0.52-1.38-1.41v-3.88h4.77v7h2.09v-8.78H182.08L182.08,136.96z"
            />
            <path
                fill={color}
                d="M187.9,135.44c0.75,0,1.31-0.54,1.31-1.29c0-0.75-0.56-1.29-1.31-1.29c-0.73,0-1.29,0.54-1.29,1.29
    		C186.61,134.9,187.17,135.44,187.9,135.44L187.9,135.44z"
            />
            <polygon
                fill={color}
                points="194.64,145.91 194.57,145.91 189.9,136.96 192.25,136.96 194.6,141.82 196.94,136.96 199.29,136.96
    		194.64,145.91 	"
            />
            <path
                fill={color}
                d="M201.41,141.35c0,1.65,0.98,2.72,2.33,2.72c1.05,0,1.67-0.56,2.14-1.31v-2.82c-0.47-0.75-1.1-1.31-2.14-1.31
    		C202.39,138.63,201.41,139.69,201.41,141.35L201.41,141.35z M205.99,137.99l0.1-1.03h1.88v8.78h-1.88l-0.1-1.03
    		c-0.49,0.66-1.37,1.2-2.7,1.2c-2.38,0-4-1.93-4-4.56c0-2.65,1.62-4.56,4-4.56C204.62,136.79,205.5,137.33,205.99,137.99
    		L205.99,137.99z"
            />
            <polygon
                fill={color}
                points="212.15,145.74 210.07,145.74 210.07,132.5 212.15,132.5 212.15,145.74 	"
            />
            <path
                fill={color}
                d="M54.82,134.51c0,0.63-0.45,1.08-1.08,1.08c-0.61,0-1.06-0.45-1.06-1.08c0-0.61,0.45-1.07,1.06-1.07
    		C54.37,133.44,54.82,133.89,54.82,134.51L54.82,134.51z M49.75,141.37c0,1.57,1.03,2.7,2.44,2.7c1.41,0,2.45-1.13,2.45-2.7
    		c0-1.59-1.04-2.73-2.45-2.73C50.78,138.63,49.75,139.78,49.75,141.37L49.75,141.37z M51.69,134.51c0,0.63-0.45,1.08-1.08,1.08
    		c-0.61,0-1.06-0.45-1.06-1.08c0-0.61,0.45-1.07,1.06-1.07C51.24,133.44,51.69,133.89,51.69,134.51L51.69,134.51z M56.75,141.37
    		c0,2.63-1.93,4.54-4.56,4.54c-2.63,0-4.56-1.91-4.56-4.54c0-2.65,1.93-4.58,4.56-4.58C54.82,136.79,56.75,138.72,56.75,141.37
    		L56.75,141.37z"
            />
            <path
                fill={color}
                d="M61.19,136.96h2.65v1.78h-2.65v3.88c0,0.89,0.56,1.41,1.38,1.41c0.56,0,0.94-0.12,1.2-0.28l0.56,1.64
    		c-0.43,0.28-1.08,0.52-1.95,0.52c-2,0-3.27-1.15-3.27-3.27v-3.9h-1.65v-1.78h1.65v-2.94h2.09V136.96L61.19,136.96z"
            />
            <path
                fill={color}
                d="M67.15,140.49h4.14c-0.05-1.2-0.75-2.04-2-2.04C68.06,138.46,67.22,139.28,67.15,140.49L67.15,140.49z
    		 M73.35,141.26v0.73h-6.2c0.05,1.39,0.89,2.16,2.35,2.16c1.03,0,1.78-0.45,2.18-1.01l1.45,1.18c-0.87,1.04-2.02,1.58-3.64,1.58
    		c-2.72,0-4.46-1.91-4.46-4.54c0-2.65,1.78-4.58,4.3-4.58C72.03,136.79,73.35,138.8,73.35,141.26L73.35,141.26z"
            />
            <path
                fill={color}
                d="M76.83,139.94v2.82c0.45,0.75,1.1,1.31,2.14,1.31c1.36,0,2.33-1.06,2.33-2.72c0-1.65-0.98-2.72-2.33-2.72
    		C77.93,138.63,77.28,139.19,76.83,139.94L76.83,139.94z M76.83,137.83c0.47-0.56,1.31-1.04,2.59-1.04c2.37,0,3.99,1.91,3.99,4.56
    		c0,2.63-1.62,4.56-3.99,4.56c-1.32,0-2.23-0.54-2.72-1.2l-0.09,1.03h-1.88V132.5h2.09V137.83L76.83,137.83z"
            />
            <path
                fill={color}
                d="M86.58,141.37c0,1.57,1.03,2.7,2.44,2.7c1.41,0,2.45-1.13,2.45-2.7c0-1.59-1.04-2.73-2.45-2.73
    		C87.61,138.63,86.58,139.78,86.58,141.37L86.58,141.37z M93.58,141.37c0,2.63-1.93,4.54-4.56,4.54c-2.63,0-4.56-1.91-4.56-4.54
    		c0-2.65,1.93-4.58,4.56-4.58C91.65,136.79,93.58,138.72,93.58,141.37L93.58,141.37z"
            />
            <path
                fill={color}
                d="M99.54,138.87h-0.17c-1.06,0-1.74,0.56-2.3,1.33v5.54h-2.09v-8.78h1.88l0.11,1.17
    		c0.43-0.7,1.32-1.34,2.58-1.34V138.87L99.54,138.87z"
            />
            <path
                fill={color}
                d="M102.44,141.29c0,1.62,0.98,2.68,2.33,2.68c1.04,0,1.69-0.56,2.14-1.31v-2.73c-0.45-0.75-1.1-1.31-2.14-1.31
    		C103.42,138.63,102.44,139.68,102.44,141.29L102.44,141.29z M107.02,137.99l0.11-1.03h1.88v8.48c0,2.79-1.83,4.47-4.62,4.47
    		c-1.9,0-3.2-0.75-4.16-1.86l1.38-1.38c0.68,0.8,1.53,1.39,2.77,1.39c1.56,0,2.54-1.04,2.54-2.58v-0.73
    		c-0.47,0.56-1.3,1.06-2.6,1.06c-2.37,0-3.99-1.92-3.99-4.53c0-2.61,1.62-4.51,3.99-4.51C105.65,136.79,106.55,137.33,107.02,137.99
    		L107.02,137.99z"
            />
            <path
                fill={color}
                d="M42.42,140.67h1.65v2.51c-0.7,0.49-1.55,0.78-2.54,0.78c-2.68,0-4.48-1.95-4.48-4.61c0-2.7,1.73-4.63,4.3-4.63
    		c1.3,0,2.35,0.58,3.09,1.37l1.47-1.47c-1.2-1.24-2.61-1.9-4.56-1.9c-3.79,0-6.51,2.82-6.51,6.63c0,3.78,2.78,6.62,6.69,6.62
    		c1.9,0,3.5-0.57,4.7-1.71v-5.47h-5.69C40.54,139.83,41.39,140.67,42.42,140.67L42.42,140.67z"
            />
            <path
                fill={color}
                d="M86.42,84.65v-4.52c0-0.49-0.4-0.89-0.89-0.89c-0.24,0-0.46,0.1-0.63,0.26l-8.77,8.77h33.63L96.43,74.95
    		C93.97,78.97,90.52,82.31,86.42,84.65L86.42,84.65z"
            />
            <path
                fill={color}
                d="M162.28,81.78L101.3,20.8c-4.05,4.05-4.05,10.61,0,14.65L126.84,61c0.69,0.69,0.69,1.82,0,2.51
    		c-0.69,0.69-1.82,0.69-2.51,0L90.66,29.83c-4.04,4.04-4.05,10.6,0,14.65L107.17,61c0.69,0.69,0.69,1.82,0,2.51
    		c-0.69,0.69-1.82,0.69-2.51,0L92.3,51.14c-4.05,4.05-4.05,10.61,0,14.65l22.48,22.48h39.06l-11.55-11.56
    		c-2.1,2.08-4.53,3.81-7.2,5.13c-0.25,0.13-0.52,0.18-0.79,0.18c-0.65,0-1.28-0.36-1.59-0.99c-0.43-0.88-0.07-1.94,0.8-2.37
    		c3.48-1.72,6.4-4.17,8.63-7.12l16.72,16.72h12.02C169.53,84.7,166.24,82.09,162.28,81.78L162.28,81.78z"
            />
            <g>
                <path
                    fill={color}
                    d="M163.6,55.82h3.53V52.3l3.74-3.74h-5.75c-2.78,0-5.29,1.13-7.11,2.94l-3.93,3.93
    			c0.19,4.03-0.39,7.92-1.61,11.53L163.6,55.82L163.6,55.82z"
                />
                <path
                    fill={color}
                    d="M149.63,64.11c2.48-9.28,0.08-19.6-7.2-26.88l-6.88-6.88c-0.69-0.69-0.69-1.81,0-2.51
    			c0.69-0.69,1.82-0.69,2.51,0l10.46,10.45c3.44-3.03,4.34-7.98,2.35-11.99l-0.62,0.61c-0.35,0.35-0.91,0.35-1.25,0l-3.96-3.96
    			c-0.32-0.32-0.52-0.76-0.52-1.25v-1.02c0-0.49-0.2-0.93-0.52-1.25l-7.14-7.14c-0.32-0.32-0.52-0.76-0.52-1.25V9.08
    			c0-0.49-0.2-0.93-0.52-1.26l-4.2-4.2c-0.99-0.99-1.72-2.24-2.09-3.63c-1.56,1.58-1.56,4.12,0.01,5.7c2.4,2.4,2.4,6.28,0,8.68
    			l-5.06,5.06c-5.39,5.39-5.39,14.13,0,19.52L149.63,64.11L149.63,64.11z"
                />
            </g>
            <path
                fill={color}
                d="M48.55,87.04c-0.13-0.1-0.26-0.19-0.39-0.29c-2.03-1.59-4.38-5.02-5.42-7.59c2.77,0.05,6.82,1.02,9.02,2.34
    		c0.14,0.08,0.28,0.17,0.41,0.26c0.05,0.03,0.09,0.07,0.14,0.1c0.03,0.02,0.06,0.04,0.1,0.06c0.1,0.06,0.19,0.13,0.27,0.21
    		c0.16,0.13,0.32,0.29,0.48,0.47c0.33,0.34,0.62,0.71,0.83,1.09c0.86,1.32,1.59,3.05,1.9,4.52c-1.48,0.24-3.36,0.18-4.91-0.15
    		c-0.43-0.07-0.87-0.2-1.31-0.39c-0.22-0.08-0.43-0.18-0.61-0.28c-0.1-0.05-0.2-0.11-0.29-0.18c-0.04-0.02-0.06-0.05-0.1-0.07
    		C48.65,87.1,48.6,87.07,48.55,87.04L48.55,87.04z"
            />
            <path
                fill={color}
                d="M61.01,82.76c0.05-0.16,0.09-0.32,0.13-0.48c0.62-2.5,0.37-6.64-0.39-9.31c-2.16,1.74-4.75,4.99-5.69,7.38
    		c-0.06,0.15-0.11,0.3-0.16,0.46c-0.02,0.06-0.03,0.11-0.05,0.16c-0.01,0.04-0.03,0.07-0.04,0.11c-0.04,0.11-0.07,0.22-0.08,0.33
    		c-0.05,0.2-0.08,0.43-0.1,0.67c-0.05,0.48-0.05,0.94,0.01,1.37c0.13,1.58,0.62,3.39,1.28,4.73c1.31-0.72,2.76-1.93,3.77-3.14
    		c0.3-0.32,0.56-0.69,0.79-1.1c0.12-0.21,0.23-0.41,0.31-0.6c0.05-0.1,0.09-0.21,0.12-0.32c0.01-0.04,0.02-0.08,0.03-0.12
    		C60.97,82.87,60.99,82.82,61.01,82.76L61.01,82.76z"
            />
            <path
                fill={color}
                d="M46.31,72.61c-0.1-0.11-0.19-0.22-0.29-0.33c-1.47-1.79-2.88-5.26-3.29-7.72c2.43,0.58,5.8,2.21,7.48,3.8
    		c0.11,0.1,0.21,0.2,0.32,0.31c0.03,0.04,0.07,0.08,0.1,0.12c0.03,0.03,0.05,0.05,0.07,0.07c0.07,0.08,0.14,0.15,0.2,0.24
    		c0.12,0.15,0.23,0.32,0.34,0.51c0.22,0.37,0.4,0.74,0.52,1.12c0.5,1.33,0.81,2.99,0.8,4.34c-1.35-0.08-2.98-0.49-4.28-1.08
    		c-0.36-0.14-0.72-0.34-1.07-0.59c-0.18-0.12-0.34-0.24-0.49-0.37c-0.08-0.07-0.15-0.14-0.23-0.21c-0.02-0.03-0.04-0.05-0.07-0.08
    		C46.39,72.69,46.35,72.65,46.31,72.61L46.31,72.61z"
            />
            <path
                fill={color}
                d="M58.09,71.26c0.07-0.13,0.14-0.26,0.21-0.39c1.03-2.07,1.61-5.77,1.45-8.26c-2.23,1.11-5.14,3.46-6.43,5.39
    		c-0.08,0.12-0.16,0.25-0.23,0.38c-0.03,0.04-0.05,0.09-0.08,0.13c-0.02,0.03-0.04,0.06-0.06,0.09c-0.05,0.09-0.1,0.18-0.14,0.28
    		c-0.08,0.17-0.15,0.36-0.21,0.56c-0.14,0.41-0.22,0.82-0.25,1.21c-0.19,1.41-0.11,3.1,0.21,4.41c1.29-0.38,2.8-1.16,3.92-2.03
    		c0.32-0.22,0.63-0.5,0.91-0.82c0.15-0.16,0.28-0.32,0.39-0.47c0.06-0.08,0.12-0.17,0.17-0.26c0.02-0.03,0.03-0.07,0.05-0.1
    		C58.04,71.35,58.07,71.31,58.09,71.26L58.09,71.26z"
            />
            <path
                fill={color}
                d="M46.93,59.63c-0.07-0.11-0.13-0.23-0.2-0.34c-1.01-1.82-1.68-5.12-1.65-7.37c2.05,0.91,4.77,2.91,5.99,4.59
    		c0.08,0.11,0.15,0.22,0.23,0.33c0.02,0.04,0.04,0.08,0.07,0.12c0.02,0.03,0.04,0.05,0.05,0.08c0.05,0.08,0.1,0.16,0.14,0.24
    		c0.08,0.15,0.15,0.32,0.21,0.51c0.14,0.36,0.23,0.72,0.28,1.07c0.22,1.26,0.22,2.78-0.01,3.97c-1.18-0.29-2.56-0.93-3.61-1.66
    		c-0.3-0.19-0.58-0.42-0.85-0.7c-0.14-0.13-0.26-0.27-0.37-0.4c-0.06-0.07-0.11-0.15-0.16-0.23c-0.02-0.03-0.03-0.06-0.05-0.09
    		C46.98,59.71,46.95,59.67,46.93,59.63L46.93,59.63z"
            />
            <path
                fill={color}
                d="M57.57,60.37c0.09-0.1,0.17-0.21,0.25-0.31c1.25-1.66,2.38-4.84,2.65-7.07c-2.16,0.61-5.12,2.22-6.57,3.71
    		c-0.09,0.1-0.18,0.19-0.27,0.3c-0.03,0.04-0.06,0.07-0.09,0.11c-0.02,0.02-0.04,0.04-0.06,0.07c-0.06,0.07-0.12,0.15-0.17,0.22
    		c-0.1,0.14-0.19,0.29-0.28,0.46c-0.19,0.34-0.33,0.69-0.42,1.03c-0.4,1.22-0.61,2.72-0.55,3.93c1.21-0.12,2.67-0.56,3.81-1.15
    		c0.32-0.14,0.64-0.34,0.94-0.57c0.16-0.11,0.3-0.23,0.42-0.35c0.07-0.06,0.13-0.13,0.19-0.2c0.02-0.03,0.04-0.05,0.06-0.08
    		C57.51,60.44,57.54,60.41,57.57,60.37L57.57,60.37z"
            />
            <path
                fill={color}
                d="M49.66,47.98c-0.04-0.11-0.08-0.23-0.12-0.34c-0.6-1.78-0.65-4.81-0.25-6.79c1.67,1.14,3.74,3.35,4.55,5.04
    		c0.05,0.11,0.1,0.22,0.15,0.33c0.02,0.04,0.03,0.08,0.04,0.12c0.01,0.03,0.02,0.05,0.04,0.08c0.03,0.08,0.06,0.16,0.08,0.24
    		c0.05,0.15,0.08,0.31,0.11,0.48c0.07,0.34,0.09,0.68,0.07,1c-0.01,1.15-0.26,2.5-0.66,3.51c-1-0.45-2.12-1.24-2.93-2.06
    		c-0.23-0.22-0.45-0.47-0.64-0.76c-0.1-0.14-0.19-0.28-0.26-0.42c-0.04-0.07-0.07-0.15-0.11-0.23c-0.01-0.03-0.01-0.05-0.03-0.08
    		C49.69,48.06,49.67,48.02,49.66,47.98L49.66,47.98z"
            />
            <path
                fill={color}
                d="M58.95,50.38c0.1-0.08,0.19-0.15,0.27-0.24c1.38-1.27,2.89-3.9,3.5-5.82c-2.01,0.19-4.89,1.13-6.42,2.21
    		c-0.1,0.07-0.19,0.14-0.28,0.22c-0.03,0.03-0.06,0.05-0.1,0.08c-0.02,0.02-0.05,0.03-0.07,0.05c-0.07,0.06-0.13,0.11-0.18,0.17
    		c-0.11,0.11-0.22,0.23-0.33,0.37c-0.22,0.27-0.4,0.56-0.54,0.84c-0.55,1.01-0.98,2.31-1.12,3.39c1.09,0.09,2.45-0.06,3.56-0.4
    		c0.31-0.07,0.62-0.19,0.93-0.35c0.16-0.08,0.3-0.16,0.43-0.25c0.07-0.04,0.14-0.09,0.2-0.14c0.02-0.02,0.04-0.04,0.07-0.06
    		C58.89,50.42,58.92,50.4,58.95,50.38L58.95,50.38z"
            />
            <path
                fill={color}
                d="M53.82,37.97c-0.02-0.1-0.04-0.21-0.06-0.31c-0.3-1.66,0.05-4.37,0.67-6.08c1.33,1.24,2.88,3.48,3.38,5.1
    		c0.03,0.1,0.06,0.2,0.09,0.31c0.01,0.03,0.02,0.07,0.02,0.11c0.01,0.03,0.02,0.05,0.02,0.07c0.02,0.07,0.03,0.15,0.04,0.22
    		c0.02,0.14,0.03,0.28,0.03,0.44c0.01,0.31-0.01,0.62-0.07,0.9c-0.16,1.02-0.56,2.19-1.05,3.04c-0.83-0.53-1.72-1.38-2.33-2.22
    		c-0.18-0.22-0.34-0.48-0.47-0.76c-0.07-0.14-0.13-0.28-0.18-0.41c-0.03-0.07-0.05-0.15-0.06-0.22c-0.01-0.03-0.01-0.05-0.02-0.08
    		C53.84,38.05,53.83,38.01,53.82,37.97L53.82,37.97z"
            />
            <path
                fill={color}
                d="M61.78,41.34c0.09-0.06,0.19-0.11,0.27-0.17c1.39-0.95,3.09-3.08,3.88-4.72c-1.82-0.1-4.5,0.36-6.01,1.12
    		c-0.1,0.05-0.19,0.1-0.29,0.16c-0.03,0.02-0.06,0.04-0.09,0.06c-0.02,0.01-0.05,0.02-0.07,0.04c-0.07,0.04-0.13,0.08-0.19,0.12
    		c-0.11,0.08-0.22,0.18-0.34,0.28c-0.24,0.21-0.44,0.44-0.59,0.68c-0.63,0.83-1.18,1.92-1.45,2.87c0.96,0.22,2.19,0.27,3.22,0.12
    		c0.28-0.03,0.58-0.09,0.87-0.19c0.15-0.05,0.29-0.1,0.42-0.16c0.07-0.03,0.13-0.07,0.2-0.1c0.02-0.01,0.04-0.03,0.07-0.04
    		C61.71,41.38,61.74,41.36,61.78,41.34L61.78,41.34z"
            />
            <path
                fill={color}
                d="M59.33,29.03c0-0.1-0.01-0.19,0-0.29c0.01-1.52,0.76-3.86,1.58-5.27c0.98,1.31,1.99,3.55,2.17,5.06
    		c0.01,0.09,0.02,0.19,0.03,0.29c0,0.03,0,0.07,0,0.1c0,0.02,0,0.05,0.01,0.07c0.01,0.07,0,0.14,0,0.2c0,0.12-0.02,0.26-0.05,0.4
    		c-0.04,0.28-0.11,0.54-0.21,0.78c-0.31,0.88-0.85,1.85-1.42,2.52c-0.65-0.6-1.3-1.5-1.7-2.34c-0.12-0.23-0.22-0.48-0.29-0.75
    		c-0.04-0.14-0.07-0.27-0.09-0.39c-0.01-0.07-0.02-0.14-0.02-0.21c0-0.02,0-0.05,0-0.07C59.33,29.1,59.33,29.06,59.33,29.03
    		L59.33,29.03z"
            />
            <path
                fill={color}
                d="M65.83,33.3c0.09-0.04,0.18-0.07,0.27-0.11c1.39-0.61,3.24-2.23,4.2-3.55c-1.59-0.38-4.04-0.42-5.5,0.01
    		c-0.1,0.03-0.19,0.06-0.28,0.09c-0.03,0.01-0.06,0.02-0.09,0.04c-0.02,0.01-0.04,0.01-0.07,0.02c-0.06,0.03-0.12,0.05-0.18,0.08
    		c-0.11,0.05-0.23,0.12-0.35,0.19c-0.24,0.15-0.46,0.32-0.63,0.51c-0.69,0.63-1.36,1.51-1.75,2.31c0.81,0.35,1.9,0.59,2.83,0.62
    		c0.26,0.02,0.53,0.01,0.8-0.03c0.14-0.02,0.27-0.04,0.39-0.07c0.07-0.01,0.13-0.03,0.19-0.06c0.02-0.01,0.05-0.02,0.07-0.03
    		C65.76,33.32,65.79,33.31,65.83,33.3L65.83,33.3z"
            />
            <path
                fill={color}
                d="M67.11,22.9c0.06-0.06,0.12-0.12,0.19-0.18c0.99-0.94,2.97-1.92,4.4-2.27c-0.24,1.45-1.06,3.51-1.92,4.57
    		c-0.06,0.07-0.11,0.13-0.17,0.2c-0.02,0.02-0.04,0.04-0.06,0.06c-0.02,0.02-0.03,0.03-0.04,0.05c-0.04,0.04-0.08,0.09-0.13,0.13
    		c-0.09,0.07-0.18,0.15-0.28,0.22c-0.21,0.15-0.42,0.27-0.64,0.35c-0.76,0.35-1.73,0.61-2.52,0.65c-0.02-0.8,0.17-1.78,0.46-2.57
    		c0.07-0.22,0.17-0.44,0.3-0.66c0.06-0.11,0.13-0.21,0.19-0.3c0.04-0.05,0.08-0.09,0.12-0.14c0.01-0.02,0.03-0.03,0.05-0.04
    		C67.07,22.95,67.09,22.93,67.11,22.9L67.11,22.9z"
            />
            <path
                fill={color}
                d="M198.45,87.04c0.13-0.1,0.26-0.19,0.39-0.29c2.02-1.59,4.38-5.02,5.42-7.59c-2.77,0.05-6.82,1.02-9.02,2.34
    		c-0.14,0.08-0.28,0.17-0.41,0.26c-0.05,0.03-0.09,0.07-0.14,0.1c-0.03,0.02-0.06,0.04-0.1,0.06c-0.1,0.06-0.19,0.13-0.27,0.21
    		c-0.16,0.13-0.32,0.29-0.48,0.47c-0.33,0.34-0.62,0.71-0.83,1.09c-0.86,1.32-1.59,3.05-1.9,4.52c1.48,0.24,3.36,0.18,4.91-0.15
    		c0.43-0.07,0.87-0.2,1.31-0.39c0.22-0.08,0.43-0.18,0.61-0.28c0.1-0.05,0.2-0.11,0.29-0.18c0.03-0.02,0.06-0.05,0.1-0.07
    		C198.35,87.1,198.4,87.07,198.45,87.04L198.45,87.04z"
            />
            <path
                fill={color}
                d="M186,82.76c-0.05-0.16-0.09-0.32-0.13-0.48c-0.62-2.5-0.37-6.64,0.39-9.31c2.16,1.74,4.75,4.99,5.69,7.38
    		c0.06,0.15,0.11,0.3,0.16,0.46c0.02,0.06,0.03,0.11,0.05,0.16c0.01,0.04,0.03,0.07,0.04,0.11c0.04,0.11,0.07,0.22,0.09,0.33
    		c0.05,0.2,0.07,0.43,0.09,0.67c0.05,0.48,0.05,0.94-0.01,1.37c-0.13,1.58-0.62,3.39-1.28,4.73c-1.31-0.72-2.76-1.93-3.77-3.14
    		c-0.29-0.32-0.56-0.69-0.79-1.1c-0.12-0.21-0.23-0.41-0.31-0.6c-0.05-0.1-0.09-0.21-0.12-0.32c-0.01-0.04-0.02-0.08-0.03-0.12
    		C186.03,82.87,186.02,82.82,186,82.76L186,82.76z"
            />
            <path
                fill={color}
                d="M200.69,72.61c0.1-0.11,0.19-0.22,0.29-0.33c1.47-1.79,2.88-5.26,3.29-7.72c-2.43,0.58-5.8,2.21-7.48,3.8
    		c-0.11,0.1-0.21,0.2-0.32,0.31c-0.03,0.04-0.07,0.08-0.1,0.12c-0.03,0.03-0.05,0.05-0.08,0.07c-0.07,0.08-0.13,0.15-0.2,0.24
    		c-0.12,0.15-0.23,0.32-0.34,0.51c-0.22,0.37-0.4,0.74-0.52,1.12c-0.5,1.33-0.81,2.99-0.8,4.34c1.35-0.08,2.98-0.49,4.28-1.08
    		c0.36-0.14,0.72-0.34,1.07-0.59c0.18-0.12,0.34-0.24,0.49-0.37c0.08-0.07,0.15-0.14,0.23-0.21c0.02-0.03,0.04-0.05,0.07-0.08
    		C200.61,72.69,200.65,72.65,200.69,72.61L200.69,72.61z"
            />
            <path
                fill={color}
                d="M188.91,71.26c-0.08-0.13-0.14-0.26-0.21-0.39c-1.03-2.07-1.61-5.77-1.46-8.26c2.23,1.11,5.14,3.46,6.43,5.39
    		c0.08,0.12,0.16,0.25,0.23,0.38c0.03,0.04,0.05,0.09,0.08,0.13c0.02,0.03,0.04,0.06,0.06,0.09c0.05,0.09,0.1,0.18,0.14,0.28
    		c0.08,0.17,0.15,0.36,0.21,0.56c0.14,0.41,0.22,0.82,0.25,1.21c0.19,1.41,0.11,3.1-0.21,4.41c-1.29-0.38-2.79-1.16-3.92-2.03
    		c-0.32-0.22-0.63-0.5-0.91-0.82c-0.15-0.16-0.28-0.32-0.39-0.47c-0.06-0.08-0.12-0.17-0.17-0.26c-0.02-0.03-0.03-0.07-0.05-0.1
    		C188.97,71.35,188.94,71.31,188.91,71.26L188.91,71.26z"
            />
            <path
                fill={color}
                d="M200.08,59.63c0.07-0.11,0.13-0.23,0.2-0.34c1.01-1.82,1.68-5.12,1.65-7.37c-2.05,0.91-4.77,2.91-5.99,4.59
    		c-0.08,0.11-0.15,0.22-0.23,0.33c-0.02,0.04-0.04,0.08-0.07,0.12c-0.02,0.03-0.04,0.05-0.05,0.08c-0.05,0.08-0.1,0.16-0.14,0.24
    		c-0.08,0.15-0.15,0.32-0.21,0.51c-0.14,0.36-0.23,0.72-0.28,1.07c-0.23,1.26-0.22,2.78,0.01,3.97c1.18-0.29,2.56-0.93,3.61-1.66
    		c0.3-0.19,0.58-0.42,0.85-0.7c0.14-0.13,0.27-0.27,0.37-0.4c0.06-0.07,0.11-0.15,0.16-0.23c0.02-0.03,0.03-0.06,0.05-0.09
    		C200.03,59.71,200.05,59.67,200.08,59.63L200.08,59.63z"
            />
            <path
                fill={color}
                d="M189.44,60.37c-0.09-0.1-0.17-0.21-0.25-0.31c-1.25-1.66-2.38-4.84-2.65-7.07c2.15,0.61,5.12,2.22,6.57,3.71
    		c0.09,0.1,0.18,0.19,0.27,0.3c0.03,0.04,0.06,0.07,0.09,0.11c0.02,0.02,0.04,0.04,0.06,0.07c0.06,0.07,0.12,0.15,0.17,0.22
    		c0.1,0.14,0.19,0.29,0.28,0.46c0.19,0.34,0.33,0.69,0.42,1.03c0.4,1.22,0.61,2.72,0.55,3.93c-1.21-0.12-2.67-0.56-3.81-1.15
    		c-0.32-0.14-0.64-0.34-0.94-0.57c-0.16-0.11-0.3-0.23-0.42-0.35c-0.07-0.06-0.13-0.13-0.19-0.2c-0.02-0.03-0.04-0.05-0.06-0.08
    		C189.5,60.44,189.47,60.41,189.44,60.37L189.44,60.37z"
            />
            <path
                fill={color}
                d="M197.35,47.98c0.04-0.11,0.08-0.23,0.12-0.34c0.59-1.78,0.65-4.81,0.25-6.79c-1.67,1.14-3.74,3.35-4.55,5.04
    		c-0.05,0.11-0.1,0.22-0.15,0.33c-0.02,0.04-0.03,0.08-0.04,0.12c-0.01,0.03-0.02,0.05-0.04,0.08c-0.03,0.08-0.06,0.16-0.08,0.24
    		c-0.05,0.15-0.08,0.31-0.11,0.48c-0.07,0.34-0.09,0.68-0.07,1c0.01,1.15,0.25,2.5,0.66,3.51c1-0.45,2.12-1.24,2.93-2.06
    		c0.23-0.22,0.45-0.47,0.64-0.76c0.1-0.14,0.19-0.28,0.26-0.42c0.04-0.07,0.07-0.15,0.11-0.23c0.01-0.03,0.02-0.05,0.03-0.08
    		C197.31,48.06,197.33,48.02,197.35,47.98L197.35,47.98z"
            />
            <path
                fill={color}
                d="M188.05,50.38c-0.1-0.08-0.19-0.15-0.28-0.24c-1.38-1.27-2.89-3.9-3.5-5.82c2.01,0.19,4.89,1.13,6.43,2.21
    		c0.1,0.07,0.19,0.14,0.29,0.22c0.04,0.03,0.06,0.05,0.09,0.08c0.02,0.02,0.05,0.03,0.07,0.05c0.07,0.06,0.13,0.11,0.18,0.17
    		c0.11,0.11,0.22,0.23,0.33,0.37c0.23,0.27,0.41,0.56,0.54,0.84c0.55,1.01,0.98,2.31,1.12,3.39c-1.09,0.09-2.45-0.06-3.56-0.4
    		c-0.31-0.07-0.62-0.19-0.93-0.35c-0.16-0.08-0.3-0.16-0.43-0.25c-0.07-0.04-0.14-0.09-0.2-0.14c-0.02-0.02-0.04-0.04-0.07-0.06
    		C188.12,50.42,188.09,50.4,188.05,50.38L188.05,50.38z"
            />
            <path
                fill={color}
                d="M193.19,37.97c0.02-0.1,0.04-0.21,0.06-0.31c0.3-1.66-0.05-4.37-0.67-6.08c-1.33,1.24-2.88,3.48-3.39,5.1
    		c-0.03,0.1-0.06,0.2-0.09,0.31c-0.01,0.03-0.02,0.07-0.02,0.11c-0.01,0.03-0.02,0.05-0.02,0.07c-0.02,0.07-0.03,0.15-0.04,0.22
    		c-0.02,0.14-0.03,0.28-0.03,0.44c-0.01,0.31,0.01,0.62,0.07,0.9c0.16,1.02,0.56,2.19,1.05,3.04c0.83-0.53,1.72-1.38,2.33-2.22
    		c0.18-0.22,0.34-0.48,0.47-0.76c0.07-0.14,0.13-0.28,0.18-0.41c0.03-0.07,0.05-0.15,0.07-0.22c0-0.03,0.01-0.05,0.01-0.08
    		C193.17,38.05,193.18,38.01,193.19,37.97L193.19,37.97z"
            />
            <path
                fill={color}
                d="M185.23,41.34c-0.09-0.06-0.19-0.11-0.28-0.17c-1.39-0.95-3.09-3.08-3.88-4.72c1.82-0.1,4.5,0.36,6.01,1.12
    		c0.1,0.05,0.19,0.1,0.29,0.16c0.03,0.02,0.06,0.04,0.09,0.06c0.02,0.01,0.05,0.02,0.07,0.04c0.07,0.04,0.13,0.08,0.19,0.12
    		c0.11,0.08,0.22,0.18,0.34,0.28c0.24,0.21,0.44,0.44,0.59,0.68c0.63,0.83,1.18,1.92,1.45,2.87c-0.96,0.22-2.19,0.27-3.22,0.12
    		c-0.28-0.03-0.58-0.09-0.87-0.19c-0.15-0.05-0.29-0.1-0.42-0.16c-0.07-0.03-0.13-0.07-0.2-0.1c-0.02-0.01-0.05-0.03-0.07-0.04
    		C185.29,41.38,185.26,41.36,185.23,41.34L185.23,41.34z"
            />
            <path
                fill={color}
                d="M187.68,29.03c0-0.1,0.01-0.19,0-0.29c-0.01-1.52-0.76-3.86-1.58-5.27c-0.98,1.31-1.99,3.55-2.17,5.06
    		c-0.01,0.09-0.02,0.19-0.02,0.29c0,0.03,0,0.07,0,0.1c0,0.02,0,0.05-0.01,0.07c-0.01,0.07,0,0.14,0,0.2c0,0.12,0.02,0.26,0.05,0.4
    		c0.04,0.28,0.11,0.54,0.21,0.78c0.31,0.88,0.85,1.85,1.42,2.52c0.65-0.6,1.29-1.5,1.7-2.34c0.12-0.23,0.22-0.48,0.29-0.75
    		c0.04-0.14,0.07-0.27,0.09-0.39c0.01-0.07,0.02-0.14,0.02-0.21c0-0.02,0-0.05,0-0.07C187.67,29.1,187.68,29.06,187.68,29.03
    		L187.68,29.03z"
            />
            <path
                fill={color}
                d="M181.18,33.3c-0.09-0.04-0.18-0.07-0.27-0.11c-1.39-0.61-3.24-2.23-4.2-3.55c1.59-0.38,4.05-0.42,5.5,0.01
    		c0.09,0.03,0.19,0.06,0.28,0.09c0.03,0.01,0.06,0.02,0.09,0.04c0.02,0.01,0.04,0.01,0.07,0.02c0.06,0.03,0.12,0.05,0.18,0.08
    		c0.11,0.05,0.23,0.12,0.35,0.19c0.24,0.15,0.46,0.32,0.63,0.51c0.69,0.63,1.36,1.51,1.75,2.31c-0.81,0.35-1.9,0.59-2.83,0.62
    		c-0.26,0.02-0.52,0.01-0.8-0.03c-0.14-0.02-0.27-0.04-0.39-0.07c-0.06-0.01-0.13-0.03-0.19-0.06c-0.02-0.01-0.05-0.02-0.07-0.03
    		C181.24,33.32,181.21,33.31,181.18,33.3L181.18,33.3z"
            />
            <path
                fill={color}
                d="M179.89,22.9c-0.06-0.06-0.12-0.12-0.18-0.18c-0.99-0.94-2.97-1.92-4.4-2.27c0.24,1.45,1.06,3.51,1.92,4.57
    		c0.06,0.07,0.11,0.13,0.17,0.2c0.02,0.02,0.04,0.04,0.06,0.06c0.02,0.02,0.03,0.03,0.04,0.05c0.04,0.04,0.09,0.09,0.13,0.13
    		c0.08,0.07,0.18,0.15,0.28,0.22c0.21,0.15,0.42,0.27,0.64,0.35c0.76,0.35,1.72,0.61,2.52,0.65c0.02-0.8-0.17-1.78-0.46-2.57
    		c-0.07-0.22-0.17-0.44-0.31-0.66c-0.06-0.11-0.13-0.21-0.19-0.3c-0.04-0.05-0.08-0.09-0.12-0.14c-0.02-0.02-0.03-0.03-0.05-0.04
    		C179.93,22.95,179.92,22.93,179.89,22.9L179.89,22.9z"
            />
        </g>
    </svg>
);

GoteborgIcon.propTypes = propTypes;
GoteborgIcon.defaultProps = defaultProps;

export default GoteborgIcon;
